<script>
// Iconsax Bold `flash` — raio. Primeiro uso: card "Créditos consumidos" do painel de uso
// de créditos (`ai-framework/components/creditos-uso-painel`).
export default {
  name: 'IconFlash',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.67 8.85H14.19V4.05C14.19 1.99 13.07 1.57 11.71 3.12L10.73 4.23L2.44 13.66C1.3 14.95 1.78 16.01 3.5 16.01H7.98V20.81C7.98 22.87 9.1 23.29 10.46 21.74L11.44 20.63L19.73 11.2C20.87 9.91 20.39 8.85 18.67 8.85Z"
      :fill="color"
    />
  </svg>
</template>
